module.exports = __webpack_public_path__ + "console/img/优速.11cff868.jpg";